var headerIn = {
    dispositivo: null,
    canal: null,
    medio: null,
    aplicacion: null,
    tipoTransaccion: null,
    usuario: null,
    uuid: null,
    fechaHora: null,
    idioma: null,
    empresa: null,
    geolocalizacion: null,
    token: ''
};
var url = (process.env.REACT_APP_URL) ? process.env.REACT_APP_URL : 'http://localhost:9000';
var urlDominioWom = process.env.REACT_APP_WOM_DOMINIO;
var urlDominioWomRecaudo = process.env.REACT_APP_WOM_DOMINIO_RECAUDO;
var urlConsultaFacturas = process.env.REACT_APP_EPAYCO_REST_RECAUDO_API_INVOICE;
var urlRestRecaudo = process.env.REACT_APP_REST_RECAUDO;
var urlTokenRecaudo = process.env.REACT_APP_TOKEN_RECAUDO;
var womPublicKey = process.env.REACT_WOM_PUBLIC_KEY;
var urlCheckout = process.env.REACT_APP_EPAYCO_APP_CHECKOUT;
var checkoutTest = process.env.REACT_APP_CHECKOUT_TEST;
var urlFront = process.env.REACT_APP_URL;
var urlRecaudoConfirmacion = process.env.REACT_APP_EPAYCO_REST_RECAUDO_CONFIRMACION;
var urlTransaccionInfo = process.env.REACT_APP_EPAYCO_INFO_TRANSACCION;
var urlTransaccionEmail = process.env.REACT_APP_EPAYCO_EMAIL_TRANSACCION;
var urlS3 = process.env.REACT_APP_URL_S3;
var urlFtp = process.env.REACT_APP_URL_FTP;
var CaptchaKey = process.env.REACT_APP_CAPTCHA_KEY_V3 || "";
var config = {
    api: url,
    headerIn: headerIn,
    urlDominioWom: urlDominioWom,
    urlDominioWomRecaudo: urlDominioWomRecaudo,
    urlConsultaFacturas: urlConsultaFacturas,
    urlRestRecaudo: urlRestRecaudo,
    urlTokenRecaudo: urlTokenRecaudo,
    womPublicKey: womPublicKey,
    urlCheckout: urlCheckout,
    checkoutTest: checkoutTest,
    urlFront: urlFront,
    urlRecaudoConfirmacion: urlRecaudoConfirmacion,
    urlTransaccionInfo: urlTransaccionInfo,
    urlTransaccionEmail: urlTransaccionEmail,
    urlS3: urlS3,
    urlFtp: urlFtp,
    CaptchaKey: CaptchaKey
};
export default config;
